import { createSlice } from "@reduxjs/toolkit";

const addressBookSlice = createSlice({
    name: "addressBook",
    initialState: {
        IsAdding: false,
        IsAddingAfterLogin: false,
        IsAfterLogin: false,
        AddressToAdd: null,
        StatusMessage: {message: '', error: false, type: ''},
        IsDonorLoggedIn: false,
        LoginAttemptSuccessful: false,
        LoginAttemptResponse: '',
        DonorAddresses: []
    },
    reducers: {
        setInitialState: (state, action) => {
            //action payload
            state.IsDonorLoggedIn = action.payload.IsDonorLoggedIn;
            state.DonorAddresses = action.payload.DonorAddresses;
        },
        setLoginResult: (state, action) => {
            if(action.payload.isAuthenticated) {
                state.LoginAttemptSuccessful = true;
                state.IsDonorLoggedIn = true;
                state.LoginAttemptResponse = action.payload;
                state.IsAfterLogin = true;
                if (state.AddressToAdd) {
                    state.IsAddingAfterLogin = true;
                }
            } else {
                state.LoginAttemptSuccessful = false;
                state.LoginAttemptResponse = action.payload.error;
            }
        },
        setStatusMessage: (state, action) => {
            state.StatusMessage = action.payload;
        },
        setAddingAddress: (state, action) => {
            console.log('setAddingAddress called with:', action.payload);
            state.IsAdding = true;
            // Make sure we preserve the UserId
            state.AddressToAdd = {
                ...action.payload,
                UserId: action.payload.UserId || 0
            };
        },
        resetAddingAddress: (state, action) => {
            state.IsAdding = false;
            state.IsAddingAfterLogin = false;
            state.AddressToAdd = null;
        },
        resetAfterLogin: (state, action) => {
            state.IsAfterLogin = false;
            if(action.payload) {
                state.IsAddingAfterLogin = true;
            }
        }
    }
});

export const addressBookActions = addressBookSlice.actions;

export default addressBookSlice;